/*
 * sdv-i18n.js — micro-i18n pour le contenu rendu en JavaScript (marketplace maison).
 *
 * Le contenu Shopify natif (produits, thème) est traduit par Translate & Adapt.
 * Ce helper couvre UNIQUEMENT les chaînes injectées côté client par nos scripts
 * (sdv-marketplace.js, sdv-cart.js, …), que Shopify ne voit pas.
 *
 * Usage :  SDV_T('cle', 'Texte français par défaut')
 *   - lit la langue active depuis <html lang> (request.locale.iso_code) ;
 *   - renvoie la traduction EN/ES si dispo, sinon le fallback français fourni.
 *   - donc AUCUN risque de régression : sans traduction, on affiche le français.
 *
 * Interpolation simple : SDV_T('cle', 'Bonjour {name}', { name: 'X' })
 */
(function () {
  var LANG = (document.documentElement.getAttribute("lang") || "fr").slice(0, 2).toLowerCase();

  // Dictionnaires de surcharge (FR = fallback inline dans le code appelant).
  var DICT = {
    en: {
      // Commandes acheteur / factures
      "order.invoice.download": "Download {doc}",
      "order.invoice.doc.invoice": "invoice",
      "order.invoice.doc.receipt": "receipt",
      "order.doc.invoice": "Invoice",
      "order.doc.creditNote": "Credit note",
      "order.pickup": "Collection from the seller",
      "order.servicePoint": "Pickup point",
      "order.tracking": "Tracking",
      "order.empty": "No marketplace purchases yet.",
      "order.loadError": "Unable to load your marketplace purchases.",
      // Devis livraison (acheteur)
      "devis.status.pending": "Awaiting the seller",
      "devis.status.proposed": "Quote received — accept or decline",
      "devis.status.accepted": "Accepted — to be paid",
      "devis.status.refused": "Declined",
      "devis.status.paid": "Paid ✓",
      "devis.status.expired": "Expired",
      "devis.status.cancelled": "Cancelled",
      "devis.accept": "Accept",
      "devis.shipping": "shipping",
      "devis.shipTo": "Ship to",
      "common.total": "total",
      "common.refuse": "Decline",
      "common.pay": "Pay",
      "common.cancel": "Cancel",
      "msg.empty": "No conversations yet. Your exchanges will appear here.",
      // Produits vendeur
      "vp.empty": "You don't have any active products yet.",
      "vp.count": "{n} items on sale",
      "vp.priceTBD": "Price to be confirmed",
      "vp.tag.moderation": "Under review",
      "vp.tag.sold": "Sold",
      "vp.tag.published": "Published",
      "vp.tag.expired": "Expired",
      "ship.mode.ship": "Home or collection point",
      "ship.mode.pickup": "Home or collection point",
      "ship.mode.ship_or_pickup": "Home or collection point",
      "ship.mode.quote": "On quote",
      "ship.mode.default": "Delivery",
      "ship.tier.small": "small parcel",
      "ship.tier.medium": "standard parcel",
      "ship.tier.large": "large parcel",
      "ship.tier.fragile": "fragile",
      "ship.tier.furniture": "furniture / bulky",
      "ship.tier.default": "parcel",
      // Édition / suppression / prolongation / étiquette (vendeur)
      "common.save": "Save",
      "common.saving": "Saving…",
      "common.deleting": "Deleting…",
      "vp.edit.invalidTitlePrice": "A valid title and price are required.",
      "vp.edit.invalidStock": "Invalid stock.",
      "vp.edit.updateError": "Error while updating.",
      "vp.edit.deleteError": "Unable to delete.",
      "vp.edit.confirmDelete": "Yes, delete",
      "vp.renew.loading": "Extending...",
      "vp.renew.error": "Unable to extend.",
      "vp.renew.cta": "Extend",
      "vp.label.loading": "Creating label...",
      "vp.label.error": "Label unavailable.",
      // Divers communs + boosts
      "common.redirecting": "Redirecting…",
      "common.networkError": "Network error.",
      "common.retry": "Try again",
      "common.until": "until",
      "common.month": "month",
      "boost.payError": "Unable to start the payment.",
      "boost.shopActive": "✓ Shop promoted",
      "boost.shopCta": "Promote my shop",
      "boost.unavailable": "Boosts are not available at the moment.",
      "boost.productTitle": "Boost this listing",
      "boost.productDesc": "Appears at the top of the marketplace with a “Featured” badge.",
      "boost.awaitingApproval": "Boost saved: payment offered once the listing is approved.",
      "boost.prelaunch": "Available once the marketplace opens to buyers. There is no point paying for visibility while the shop is not public yet.",
      "boost.shopActiveNote": "One-off purchase: the promotion ends on that date, with no renewal and no automatic payment. You get a reminder 3 days before.",
      "boost.oneShot": "One-off {days}-day purchase: no subscription, no automatic payment. When it ends, you can buy it again if you want to.",
      "boost.oneShotProduct": "One-off purchase, 20% VAT included: no subscription, no automatic payment.",
      "boost.oneShotProductSimple": "One-off purchase: no subscription, no automatic payment.",
      "boost.ttc": "incl. VAT",
      "boost.ht": "excl. VAT",
      "boost.vat": "of VAT",
      "boost.sellerBadge": "Featured shop",
      "boost.perk.featured": "Your shop shown in “Sellers to follow” on the marketplace page",
      "boost.perk.badge": "“Featured shop” badge on your card and on your public page",
      "boost.perk.rating": "Your rating and review count highlighted next to your name",
      "boost.perk.duration": "Visible for {days} days from the payment",
      "boost.perk.productRow": "Your listing in the “Featured products” row of the marketplace",
      "boost.perk.productBadge": "“★ Featured” badge on the listing photo",
      "boost.perk.productDuration": "For the whole duration of the plan you pick",
      // Erreurs communes
      "common.sendError": "Sending failed.",
      "common.actionError": "Action failed.",
      "common.opError": "Operation failed.",
      // Profil vendeur / avatar / payout / avis
      "profile.avatar.notImage": "The file must be an image.",
      "profile.avatar.tooBig": "Image too large. Use an image under 5 MB.",
      "profile.avatar.importing": "Uploading photo…",
      "profile.avatar.uploadError": "Upload failed.",
      "profile.avatar.imported": "Photo uploaded. Save to publish.",
      "profile.avatar.importError": "Error while uploading the photo.",
      "profile.saving": "Saving the public page...",
      "profile.updateError": "Update failed.",
      "profile.updated": "Public page updated.",
      "profile.saveError": "Error while saving.",
      "payout.saving": "Saving payment details...",
      "payout.saveError": "Saving failed.",
      "payout.saved": "Details saved for review.",
      "payout.status.paid": "Paid",
      "payout.status.available": "Ready for payout",
      "payout.status.blocked": "Awaiting delivery",
      "payout.status.cancelled": "Cancelled",
      "payout.invoice": "Commission invoice",
      "reviews.empty": "No reviews yet.",
      "reviews.chooseRating": "Please choose a rating.",
      "vp.soon": "Your products will be available here soon.",
      "vp.label.retry": "Label unavailable right now, please try again.",
      "vp.label.print": "Print label",
      "vp.rateUnavailable": "Rate unavailable",
      // Offre / question / devis (soumission)
      "common.error": "Error",
      "msg.contactMasked": "For your safety and in accordance with Salon du Vintage rules, sharing contact details (email, phone, social media, links) is not allowed: this information has been hidden in your message.",
      "offer.invalidAmount": "Enter a valid amount.",
      "offer.sent": "Offer sent to the seller ✓",
      "question.write": "Write your question.",
      "question.sent": "Question sent ✓",
      "devis.postalRequired": "Enter your postal code.",
      "devis.requestSent": "Request sent to the seller ✓",
      // Messagerie inaccessible
      "msg.sessionExpiree": "Your session has expired: sign in again to see your messages.",
      "msg.reconnexion": "Sign in again",
      "msg.sansBoutique": "No shop is linked to this account. Write to us if this is a mistake.",
      "msg.erreurChargement": "Your messages could not be loaded. Please try again shortly.",
      "msg.indisponible": "Messages unavailable",
      // Carte d'offre dans le fil de discussion
      "offer.title": "Offer",
      "offer.counter": "Counter-offer",
      "offer.counterShort": "Counter",
      "offer.yourPrice": "Your price",
      "offerB.cancel": "Cancel my offer",
      "common.accept": "Accept",
      "common.send": "Send",
      // Statuts d'offre (vendeur)
      "offer.st.pending": "Pending",
      "offer.st.acceptedPay": "Accepted · awaiting payment",
      "offer.st.refused": "Declined",
      "offer.st.countered": "Countered",
      "offer.st.paid": "Paid ✓",
      "offer.st.expired": "Expired",
      "offer.st.cancelled": "Cancelled",
      // Statuts d'offre (acheteur)
      "offerB.st.pending": "Awaiting the seller",
      "offerB.st.toPay": "Accepted — to be paid",
      "offerB.st.countered": "Counter-offer received",
      // Statuts de devis (vendeur)
      "devisS.st.pending": "Awaiting your reply",
      "devisS.st.sent": "Quote sent · pending",
      "devisS.st.accepted": "Accepted · awaiting payment",
      "devisS.st.refused": "Declined",
      "devisS.st.paid": "Paid ✓",
      "devisS.st.expired": "Expired",
      "devisS.st.cancelled": "Cancelled",
      // Formulaire création / édition d'annonce
      "common.imageReadError": "Could not read the image.",
      "listing.boostAfterApproval": "Payment for your boost will be offered once the listing is approved.",
      "listing.resubmitted": "Listing resubmitted. Our team will review it again.",
      "listing.submitted": "Product submitted for review.",
      "listing.backToDashboard": "Back to your seller area...",
      "listing.submitError": "Error while submitting.",
      "listing.noValidImage": "No valid image found.",
      "listing.imagePrepError": "One image could not be prepared.",
      "listing.imageTooLarge": "This photo is too heavy. Please resize it (about 2 MB maximum) and try again.",
      "listing.weightMax": "A carrier parcel cannot exceed 30 kg. Above that, pick “Furniture / bulky”: delivery will be quoted individually.",
      "listing.removePhoto": "Remove this photo",
      "listing.photoCount": "photo(s) ready to upload.",
      "listing.photoLimit": "Maximum 5 photos: the extra ones were ignored.",
      "listing.sending": "Sending...",
      "listing.conditionRequired": "Please indicate the condition of your item.",
      "listing.uploadingProof": "Uploading the proof…",
      "listing.imageUploadError": "Image upload failed.",
      "listing.updateError": "Update failed.",
      "listing.createError": "Creation failed.",
      "listing.fileTooBig": "The file is too large (max 5 MB).",
      "listing.editTitle": "Edit your listing.",
      "listing.newProduct": "New product",
      "listing.untitled": "Untitled",
      // Réserver un stand (JS inline)
      "rs_no_edition": "No edition open at the moment.",
      "rs_load_salons_error": "Unable to load the fairs.",
      // Mon stand (JS inline)
      "ms_plan_error": "Unable to open the plan.",
      "ms_no_stand": "No stand booked",
      "ms_under_review": "Application under review",
      "ms_application_sent": "Your application has been sent.",
      "ms_not_exhibitor": "Your account is not yet registered as an exhibitor.",
      "ms_submit_application": "Submit an application",
      "ms_applications_review": "Your applications are under review below.",
      "ms_apply_other_js": "Apply to another edition",
      "ms_load_editions_error": "Unable to load your editions.",
      "ms_all_applied": "You have already applied to all open editions.",
      "ms_load_editions_error2": "Unable to load the editions.",
      "ms_no_reservation": "No confirmed reservation yet.",
      "ms_reserve_from_tab": "Book a stand from the “My editions” tab.",
      "ms_download_invoice": "Download the invoice (PDF)",
      "ms_load_reservations_error": "Unable to load your reservations.",
      "ms_no_profile": "No exhibitor profile.",
      "ms_readonly_profile": "Read-only profile — it will become editable once your application is approved.",
      "ms_profile_saved": "Profile saved.",
      "ms_load_profile_error": "Unable to load the profile.",
      // Panier
      "common.seller": "Seller",
      "cart.addError": "Unable to add to cart.",
      "cart.checkoutError": "Unable to prepare the payment.",
      "cart.uniqueInCart": "This unique piece is already in your cart.",
      "cart.stockAvailable": "Available stock: {n} item(s).",
      "cart.empty": "Your cart is empty.",
      "cart.emptyCta": "Add pieces from the marketplace.",
      "cart.item": "Item",
      "cart.added": "{label} added to cart",
      "ms_accept_and_pay": "Accept and pay",
      "ms_accept_error": "Unable to accept the proposal.",
      "ms_add_services": "Add services",
      "ms_awaiting_transfer": "Awaiting your bank transfer",
      "ms_counter_proposed": "Another stand proposed",
      "ms_download_bon": "Booking confirmation (PDF)",
      "ms_offered": "free",
      "ms_pay_before": "To pay before",
      "ms_to_pay": "To pay",
      "ms_pay_now": "Pay now",
      "ms_transfer_instructions": "Bank transfer instructions have been emailed to you. Your stand is confirmed upon receipt.",
      "vp.remove": "Remove (sold elsewhere)",
      "vp.remove.confirm": "Remove this listing? It will be permanently deleted from sale (e.g. item sold elsewhere).",
      "vp.remove.loading": "Removing…",
      "vp.remove.error": "Removal failed.",
      "ms_f_prenom": "First name",
      "ms_f_nom": "Last name",
      "ms_f_tel": "Phone",
      "ms_f_enseigne": "Business / brand name",
      "ms_f_activite": "Type of business",
      "ms_f_siret": "Company registration no.",
      "ms_f_ville": "City",
      "ms_f_site": "Website",
      "ms_f_presentation": "About",
      "ms_validated_editions": "My approved editions",
      "ms_pending_validation": "Awaiting approval",
      "ms_save_profile": "Save my profile",
    },
    es: {
      "order.invoice.download": "Descargar {doc}",
      "order.invoice.doc.invoice": "factura",
      "order.invoice.doc.receipt": "justificante",
      "order.doc.invoice": "Factura",
      "order.doc.creditNote": "Abono",
      "order.pickup": "Recogida en el vendedor",
      "order.servicePoint": "Punto de recogida",
      "order.tracking": "Seguimiento",
      "order.empty": "Aún no hay compras en el marketplace.",
      "order.loadError": "No se pudieron cargar tus compras del marketplace.",
      // Presupuesto de envío (comprador)
      "devis.status.pending": "A la espera del vendedor",
      "devis.status.proposed": "Presupuesto recibido — aceptar o rechazar",
      "devis.status.accepted": "Aceptado — pendiente de pago",
      "devis.status.refused": "Rechazado",
      "devis.status.paid": "Pagado ✓",
      "devis.status.expired": "Caducado",
      "devis.status.cancelled": "Cancelado",
      "devis.accept": "Aceptar",
      "devis.shipping": "envío",
      "devis.shipTo": "Envío a",
      "common.total": "total",
      "common.refuse": "Rechazar",
      "common.pay": "Pagar",
      "common.cancel": "Cancelar",
      "msg.empty": "Aún no hay conversaciones. Tus intercambios aparecerán aquí.",
      // Productos del vendedor
      "vp.empty": "Aún no tienes productos activos.",
      "vp.count": "{n} artículos en venta",
      "vp.priceTBD": "Precio por confirmar",
      "vp.tag.moderation": "En revisión",
      "vp.tag.sold": "Vendido",
      "vp.tag.published": "Publicado",
      "vp.tag.expired": "Caducado",
      "ship.mode.ship": "Domicilio o punto de recogida",
      "ship.mode.pickup": "Domicilio o punto de recogida",
      "ship.mode.ship_or_pickup": "Domicilio o punto de recogida",
      "ship.mode.quote": "Bajo presupuesto",
      "ship.mode.default": "Entrega",
      "ship.tier.small": "paquete pequeño",
      "ship.tier.medium": "paquete estándar",
      "ship.tier.large": "paquete grande",
      "ship.tier.fragile": "frágil",
      "ship.tier.furniture": "mueble / voluminoso",
      "ship.tier.default": "paquete",
      // Edición / eliminación / renovación / etiqueta (vendedor)
      "common.save": "Guardar",
      "common.saving": "Guardando…",
      "common.deleting": "Eliminando…",
      "vp.edit.invalidTitlePrice": "Se requieren un título y un precio válidos.",
      "vp.edit.invalidStock": "Stock no válido.",
      "vp.edit.updateError": "Error al actualizar.",
      "vp.edit.deleteError": "No se pudo eliminar.",
      "vp.edit.confirmDelete": "Sí, eliminar",
      "vp.renew.loading": "Renovando...",
      "vp.renew.error": "No se pudo renovar.",
      "vp.renew.cta": "Renovar",
      "vp.label.loading": "Creando la etiqueta...",
      "vp.label.error": "Etiqueta no disponible.",
      // Varios comunes + boosts
      "common.redirecting": "Redirigiendo…",
      "common.networkError": "Error de red.",
      "common.retry": "Reintentar",
      "common.until": "hasta el",
      "common.month": "mes",
      "boost.payError": "No se pudo iniciar el pago.",
      "boost.shopActive": "✓ Tienda destacada",
      "boost.shopCta": "Destacar mi tienda",
      "boost.unavailable": "Los boosts no están disponibles por el momento.",
      "boost.productTitle": "Destacar este anuncio",
      "boost.productDesc": "Aparece en la parte superior del marketplace con una insignia «Destacado».",
      "boost.awaitingApproval": "Boost guardado: pago propuesto tras la validación del anuncio.",
      "boost.prelaunch": "Disponible cuando el marketplace abra a los compradores. No sirve de nada pagar visibilidad mientras la tienda no sea pública.",
      "boost.shopActiveNote": "Compra única: la promoción termina en esa fecha, sin renovación ni cobro automático. Recibirás un aviso 3 días antes.",
      "boost.oneShot": "Compra única de {days} días: sin suscripción ni cobro automático. Al vencer, puedes volver a comprarla si quieres.",
      "boost.oneShotProduct": "Compra única, IVA 20 % incluido: sin suscripción ni cobro automático.",
      "boost.oneShotProductSimple": "Compra única: sin suscripción ni cobro automático.",
      "boost.ttc": "IVA incl.",
      "boost.ht": "sin IVA",
      "boost.vat": "de IVA",
      "boost.sellerBadge": "Tienda destacada",
      "boost.perk.featured": "Tu tienda aparece en «Vendedores a seguir» en la página del marketplace",
      "boost.perk.badge": "Insignia «Tienda destacada» en tu tarjeta y en tu página pública",
      "boost.perk.rating": "Tu valoración y tus opiniones destacadas junto a tu nombre",
      "boost.perk.duration": "Visible durante {days} días desde el pago",
      "boost.perk.productRow": "Tu anuncio en la fila «Productos destacados» del marketplace",
      "boost.perk.productBadge": "Insignia «★ Destacado» en la foto del anuncio",
      "boost.perk.productDuration": "Durante toda la duración de la fórmula elegida",
      // Errores comunes
      "common.sendError": "Error al enviar.",
      "common.actionError": "Acción imposible.",
      "common.opError": "Operación imposible.",
      // Perfil vendedor / avatar / pago / reseñas
      "profile.avatar.notImage": "El archivo debe ser una imagen.",
      "profile.avatar.tooBig": "Imagen demasiado grande. Usa una imagen de menos de 5 MB.",
      "profile.avatar.importing": "Subiendo la foto…",
      "profile.avatar.uploadError": "Error al subir.",
      "profile.avatar.imported": "Foto subida. Guarda para publicar.",
      "profile.avatar.importError": "Error al subir la foto.",
      "profile.saving": "Guardando la página pública...",
      "profile.updateError": "No se pudo actualizar.",
      "profile.updated": "Página pública actualizada.",
      "profile.saveError": "Error al guardar.",
      "payout.saving": "Guardando los datos de pago...",
      "payout.saveError": "No se pudo guardar.",
      "payout.saved": "Datos guardados para validación.",
      "payout.status.paid": "Pagado",
      "payout.status.available": "Listo para pagar",
      "payout.status.blocked": "En espera de entrega",
      "payout.status.cancelled": "Cancelado",
      "payout.invoice": "Factura de comisión",
      "reviews.empty": "Aún no hay reseñas.",
      "reviews.chooseRating": "Elige una valoración.",
      "vp.soon": "Tus productos estarán disponibles aquí muy pronto.",
      "vp.label.retry": "Etiqueta no disponible ahora, inténtalo de nuevo.",
      "vp.label.print": "Imprimir la etiqueta",
      "vp.rateUnavailable": "Tarifa no disponible",
      // Oferta / pregunta / presupuesto (envío)
      "common.error": "Error",
      "msg.contactMasked": "Por tu seguridad y conforme a las reglas de Salon du Vintage, compartir datos de contacto (correo, teléfono, redes sociales, enlaces) no está permitido: esta información se ha ocultado en tu mensaje.",
      "offer.invalidAmount": "Introduce un importe válido.",
      "offer.sent": "Oferta enviada al vendedor ✓",
      "question.write": "Escribe tu pregunta.",
      "question.sent": "Pregunta enviada ✓",
      "devis.postalRequired": "Introduce tu código postal.",
      "devis.requestSent": "Solicitud enviada al vendedor ✓",
      // Mensajería no disponible
      "msg.sessionExpiree": "Tu sesión ha caducado: vuelve a iniciar sesión para ver tus mensajes.",
      "msg.reconnexion": "Iniciar sesión de nuevo",
      "msg.sansBoutique": "No hay ninguna tienda vinculada a esta cuenta. Escríbenos si es un error.",
      "msg.erreurChargement": "No se han podido cargar tus mensajes. Inténtalo de nuevo en un momento.",
      "msg.indisponible": "Mensajería no disponible",
      // Tarjeta de oferta en la conversación
      "offer.title": "Oferta",
      "offer.counter": "Contraofertar",
      "offer.counterShort": "Contra",
      "offer.yourPrice": "Tu precio",
      "offerB.cancel": "Cancelar mi oferta",
      "common.accept": "Aceptar",
      "common.send": "Enviar",
      // Estados de oferta (vendedor)
      "offer.st.pending": "Pendiente",
      "offer.st.acceptedPay": "Aceptada · pago pendiente",
      "offer.st.refused": "Rechazada",
      "offer.st.countered": "Contraofertada",
      "offer.st.paid": "Pagada ✓",
      "offer.st.expired": "Caducada",
      "offer.st.cancelled": "Cancelada",
      // Estados de oferta (comprador)
      "offerB.st.pending": "A la espera del vendedor",
      "offerB.st.toPay": "Aceptada — pendiente de pago",
      "offerB.st.countered": "Contraoferta recibida",
      // Estados de presupuesto (vendedor)
      "devisS.st.pending": "A la espera de tu respuesta",
      "devisS.st.sent": "Presupuesto enviado · pendiente",
      "devisS.st.accepted": "Aceptado · pago pendiente",
      "devisS.st.refused": "Rechazado",
      "devisS.st.paid": "Pagado ✓",
      "devisS.st.expired": "Caducado",
      "devisS.st.cancelled": "Cancelado",
      // Formulario de creación / edición de anuncio
      "common.imageReadError": "No se pudo leer la imagen.",
      "listing.boostAfterApproval": "El pago de tu boost se propondrá tras la validación del anuncio.",
      "listing.resubmitted": "Anuncio reenviado. Nuestro equipo volverá a revisarlo.",
      "listing.submitted": "Producto enviado para revisión.",
      "listing.backToDashboard": "Volviendo a tu espacio de vendedor...",
      "listing.submitError": "Error al enviar.",
      "listing.noValidImage": "No se encontró ninguna imagen válida.",
      "listing.imagePrepError": "No se ha podido preparar una imagen.",
      "listing.imageTooLarge": "Esta foto pesa demasiado. Redúcela (unos 2 MB como máximo) e inténtalo de nuevo.",
      "listing.weightMax": "Un paquete de transportista no puede superar los 30 kg. Por encima, elige «Mueble / voluminoso»: la entrega se presupuestará aparte.",
      "listing.removePhoto": "Quitar esta foto",
      "listing.photoCount": "foto(s) lista(s) para enviar.",
      "listing.photoLimit": "Máximo 5 fotos: las siguientes se han ignorado.",
      "listing.sending": "Enviando...",
      "listing.conditionRequired": "Indique el estado de su artículo.",
      "listing.uploadingProof": "Subiendo la prueba…",
      "listing.imageUploadError": "Error al subir la imagen.",
      "listing.updateError": "No se pudo actualizar.",
      "listing.createError": "No se pudo crear.",
      "listing.fileTooBig": "El archivo es demasiado grande (máx. 5 MB).",
      "listing.editTitle": "Edita tu anuncio.",
      "listing.newProduct": "Nuevo producto",
      "listing.untitled": "Sin título",
      // Reservar un stand (JS inline)
      "rs_no_edition": "Ninguna edición abierta por el momento.",
      "rs_load_salons_error": "No se pudieron cargar las ferias.",
      // Mi stand (JS inline)
      "ms_plan_error": "No se pudo abrir el plano.",
      "ms_no_stand": "Ningún stand reservado",
      "ms_under_review": "Candidatura en revisión",
      "ms_application_sent": "Tu candidatura se ha enviado.",
      "ms_not_exhibitor": "Tu cuenta aún no está registrada como expositor.",
      "ms_submit_application": "Presentar una candidatura",
      "ms_applications_review": "Tus candidaturas están en revisión a continuación.",
      "ms_apply_other_js": "Presentar candidatura a otra edición",
      "ms_load_editions_error": "No se pudieron cargar tus ediciones.",
      "ms_all_applied": "Ya te has presentado a todas las ediciones abiertas.",
      "ms_load_editions_error2": "No se pudieron cargar las ediciones.",
      "ms_no_reservation": "Aún no hay ninguna reserva confirmada.",
      "ms_reserve_from_tab": "Reserva un stand desde la pestaña «Mis ediciones».",
      "ms_download_invoice": "Descargar la factura (PDF)",
      "ms_load_reservations_error": "No se pudieron cargar tus reservas.",
      "ms_no_profile": "Ningún perfil de expositor.",
      "ms_readonly_profile": "Perfil de solo lectura — será editable una vez validada tu candidatura.",
      "ms_profile_saved": "Perfil guardado.",
      "ms_load_profile_error": "No se pudo cargar el perfil.",
      // Carrito
      "common.seller": "Vendedor",
      "cart.addError": "No se pudo añadir al carrito.",
      "cart.checkoutError": "No se pudo preparar el pago.",
      "cart.uniqueInCart": "Esta pieza única ya está en tu carrito.",
      "cart.stockAvailable": "Stock disponible: {n} unidad(es).",
      "cart.empty": "Tu carrito está vacío.",
      "cart.emptyCta": "Añade piezas desde el marketplace.",
      "cart.item": "Artículo",
      "cart.added": "{label} añadido al carrito",
      "ms_accept_and_pay": "Aceptar y pagar",
      "ms_accept_error": "No se pudo aceptar la propuesta.",
      "ms_add_services": "Añadir servicios",
      "ms_awaiting_transfer": "Esperando tu transferencia",
      "ms_counter_proposed": "Otro stand propuesto",
      "ms_download_bon": "Comprobante de reserva (PDF)",
      "ms_offered": "gratis",
      "ms_pay_before": "A pagar antes del",
      "ms_to_pay": "Por pagar",
      "ms_pay_now": "Pagar ahora",
      "ms_transfer_instructions": "Las instrucciones de transferencia se te enviaron por email. Tu stand se confirma al recibirla.",
      "vp.remove": "Retirar (vendido en otro sitio)",
      "vp.remove.confirm": "¿Retirar este anuncio? Se eliminará definitivamente de la venta (p. ej. vendido en otro sitio).",
      "vp.remove.loading": "Retirando…",
      "vp.remove.error": "No se pudo retirar.",
      "ms_f_prenom": "Nombre",
      "ms_f_nom": "Apellido",
      "ms_f_tel": "Teléfono",
      "ms_f_enseigne": "Nombre comercial / marca",
      "ms_f_activite": "Tipo de actividad",
      "ms_f_siret": "N.º de registro (SIRET)",
      "ms_f_ville": "Ciudad",
      "ms_f_site": "Sitio web",
      "ms_f_presentation": "Presentación",
      "ms_validated_editions": "Mis ediciones validadas",
      "ms_pending_validation": "En espera de validación",
      "ms_save_profile": "Guardar mi perfil",
    },
  };

  window.SDV_LANG = LANG;
  window.SDV_T = function (key, fallbackFr, vars) {
    var table = DICT[LANG];
    var str = table && table[key] != null ? table[key] : (fallbackFr != null ? fallbackFr : key);
    if (vars) {
      str = str.replace(/\{(\w+)\}/g, function (_, k) {
        return vars[k] != null ? vars[k] : "{" + k + "}";
      });
    }
    return str;
  };
})();
